import {SET_BUYIN_LIST_FILTER} from "@actions/actionTypes";
import initialStore from "../../initialStore";

export default function BuyinsListFilterReducer(state = initialStore.emeptyObj, action) {
    switch (action.type) {
        case SET_BUYIN_LIST_FILTER:
            return action.filter
        default:
            return state;
    }
}
